module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-navbar"
  }, [_c('div', {
    staticClass: "navbar-left"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "navbar-wordmark",
    attrs: {
      "src": _vm.sentrykitWordmark,
      "alt": "SentryKit 2.0"
    }
  })])]), _vm._v(" "), (_vm.$slots.filters) ? _c('div', {
    staticClass: "navbar-center"
  }, [_vm._t("filters")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-right"
  }, [_vm._t("right", function() {
    return [(_vm.userEmail) ? _c('div', {
      staticClass: "navbar-account"
    }, [_c('span', {
      staticClass: "navbar-user-email"
    }, [_vm._v(_vm._s(_vm.userEmail))]), _vm._v(" "), _c('span', {
      staticClass: "navbar-account-sep",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('button', {
      staticClass: "navbar-logout",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.signOut
      }
    }, [_vm._v("Log out")])]) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e78118a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/TopNavbar.vue
// module id = 742
// module chunks = 2